<template>
    <div class="search-button">
      <hp5-button-decorator type="primary"><button v-on:click="onButtonClick" :disabled="disabled">Search</button></hp5-button-decorator>
    </div>
</template>
  
<script setup>

    const model = useFCPModel()
    const { context, criteriaContext, breadCrumbs, hasSearched } = model
    const { criteriaSearch } = useSearch(model)

    const onButtonClick = async () => {
        // collecting info for analaytics
        const digitalData = window.digitalData || []

        const event = 'InitialSearch_submit'
        digitalData.push({
            eventData: {
            type: criteriaContext.value.type,
            name: criteriaContext.value.name,
            where: criteriaContext.value.where,
            term: criteriaContext.value.term,
            networkName: criteriaContext.value.networkName,
            },
            event: event,
        })

        // put it on context, so that, AFTER button click, 
        // switched netowrk name displays on Filter Results correspondingly
        context.value.networkName = criteriaContext.value.networkName

        await criteriaSearch()

        if (!hasSearched.value) {
            breadCrumbs.value.push({ name: 'Search results', href: '/search.html' })
        }
    }

    const disabled = computed(() => {
        const enabled = criteriaContext.value.type && criteriaContext.value.latLong
        return !enabled
    })
  
</script>
<style lang="scss" scoped>
@use '~/assets/scss/breakpoints' as *;
  
  .search-button {
    hp5-button-decorator .hp-call-to-action.primary {
      width: 100%;
    }
    @include small-up {
      hp5-button-decorator .hp-call-to-action.primary {
        width: auto;
      }
    }
  }
</style>